export default __webpack_public_path__ + "static/media/sapphire3.d6fc4adb.jpg";